import { useQuery } from '@tanstack/react-query';
import { publicGet } from '@/lib/api/publicClient';
import { publicPaymentEndpoints } from '@/lib/api/endpoints';
import type { SignedPageData } from '@/types/onlineBooking';

export const signedPageKeys = {
  all: () => ['public', 'signed'] as const,
  detail: (signedId: string) => [...signedPageKeys.all(), signedId] as const,
};

export function useSignedPageData(signedId: string) {
  return useQuery<SignedPageData>({
    queryKey: signedPageKeys.detail(signedId),
    queryFn: () => publicGet<SignedPageData>(publicPaymentEndpoints.signedPage(signedId)),
    enabled: !!signedId,
    staleTime: 5 * 60_000,
  });
}
